(function (){
    'use strict';

    angular
        .module('loyalty', [
            'ui.router',
            'ui.bootstrap',
            'ui.select',
            'ui.footable',
            'angular.morris',
            'daterangepicker'
        ]);
})();